import { render, staticRenderFns } from "./HeaderCalendar.vue?vue&type=template&id=3c53d5fa&"
import script from "./HeaderCalendar.vue?vue&type=script&lang=js&"
export * from "./HeaderCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports